// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"157": "__federation_expose_queryClient","238": "__federation_expose_account","538": "__federation_expose_AppProviders",}[chunkId] || chunkId) + ".js"
}